module.exports = __webpack_public_path__ + "img/ua.1aeecd60.svg";